export class Ratio {
  ratioId: number;
  acronym: string;
  shortName: string;
  name: string;
  description: string;
  denominator: string;
  numerator: string;
  descriptionIncludesFormulaFlag: boolean;
  availableForFinancialSearchFlag: boolean;
  accountValueType: number;
  entireFormulaISNA0: boolean;
  lastModifiedDate: Date;
  isActive: boolean;
  isPLIRatio: boolean;
  weightingFactorDenominator: string;
  weightingFactorNumerator: string;
  availableForManualAdjustment: boolean;
  hasBalanceSheetFinancialItem: boolean;
}
